export default {"src":"/_next/static/media/med.5d308139.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};